import {createFileRoute, stripSearchParams} from '@tanstack/react-router'
import {type} from 'arktype'

import stripEmptySearchParams from '@/utils/router/middlewares/stripEmptySearchParams'
import {fallbackToDefault} from '@/utils/schema/fallback'
import searchParamString from '@/utils/schema/searchParamString'

const DEFAULT_VALUES = {
  q: '',
}

const storeSearchSchema = type({
  q: fallbackToDefault(
    searchParamString.pipe((v: string) => {
      return v.trim().toLowerCase()
    }),
    DEFAULT_VALUES.q,
  ),
})

export const Route = createFileRoute('/stores/$storeId/')({
  validateSearch: storeSearchSchema,
  search: {
    middlewares: [stripSearchParams(DEFAULT_VALUES), stripEmptySearchParams()],
  },
})
